import { render, staticRenderFns } from "./RunnitPageSettings.vue?vue&type=template&id=4a54ad22&scoped=true"
import script from "./RunnitPageSettings.vue?vue&type=script&lang=ts"
export * from "./RunnitPageSettings.vue?vue&type=script&lang=ts"
import style0 from "./RunnitPageSettings.vue?vue&type=style&index=0&id=4a54ad22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54ad22",
  null
  
)

export default component.exports